<template>
	<div class="col-sm-12" :class="grid ? 'col-md-' + grid : 'col-md-12'">
		<div :class="`mb-2 ${inputGroup ? 'form-group' : ''}`">
			<label class="d-block font-weight-bold">
				{{ label }}
				<span
					v-if="!item"
					class="small text-warning"
					style="font-size: 10px"
					v-b-tooltip.hover
					title="Campo vazio!"
					><i class="fas fa-exclamation"></i
				></span>
				<b-link
					v-if="ajuda"
					href="#"
					@click.prevent="void 0"
					class="mb-2"
					variant="info"
					v-b-popover.hover.top="ajuda"
				>
					<i class="fas fa-info-circle"></i>
				</b-link>
				<span v-if="required" class="text-danger">*</span>
			</label>
			<div :class="inputGroup ? 'input-group mb-3' : ''">
				<div class="input-group-prepend" v-if="inputGroup">
					<button class="btn btn-light" @click.prevent="">
						<i :class="iconBtn" v-if="iconBtn"></i>
						<span v-else>{{ btnText }}</span>
					</button>
				</div>
				<input-tag
					v-model="item"
					v-on:input="$emit('input', uppercase ? toUpper(item) : item), $emit('change')"
					:limit="limit"
				/>
				<!-- <input
					v-model="item"
					v-on:input="$emit('input', uppercase ? toUpper(item) : item), $emit('change')"
					:type="type ? type : 'text'"
					class="form-control"
					:class="label == undefined ? (mt == undefined ? 'mt-4' : `mt-${mt}`) : ''"
					:readonly="readonly"
					:disabled="disabled"
					:placeholder="placeholder ? placeholder : label"
					:required="required"
					:style="uppercase ? 'text-transform: uppercase' : ''"
					ref="input"
				/> -->
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: [
		"limit",
		"value",
		"label",
		"required",
		"grid",
		"readonly",
		"disabled",
		"placeholder",
		"mt",
		"inputGroup",
		"iconBtn",
		"btnText",
		"uppercase",
		"ajuda",
	],
	data() {
		return { item: null };
	},
	beforeMount() {
		this.item = this.value;
	},
	watch: {
		value(n, o) {
			this.item = n;
		},
	},
	methods: {
		toUpper(item) {
			return item.toUpperCase();
		},
	},
};
</script>
<style lang="css">
.vue-input-tag-wrapper {
	min-height: calc(1.5em + 0.75rem + 2px) !important;
	padding: 0 7px !important;
	width: 100% !important;
	border-radius: 0.25rem !important;
}
.vue-input-tag-wrapper .input-tag {
	/* font-size: 1rem !important;
	background-color: #f0f0f0 !important;
	border-radius: 0.25rem !important;
	border: 1px solid #b7b9bd !important;
	color: #67686b !important;
	margin: 4px 2px 0px 2px !important;
	line-height: 1.4 !important;
	padding: 0 0.25em !important; */

	display: flex !important;
	align-items: center !important;
	background-color: #f0f0f0 !important;
	border: 1px solid rgba(60, 60, 60, 0.26) !important;
	border-radius: 4px !important;
	color: #333 !important;
	line-height: 1.4 !important;
	margin: 4px 2px 0px 2px !important;
	padding: 0 0.25em !important;
}
.vue-input-tag-wrapper .input-tag .remove {
	color: #b7b7b7 !important;
}
</style>
